// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"a2b9659f","705":"a6534378"}[chunkId] + ".chunk.js";
};